// src/components/Header.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import logoImage from '../assets/images/logo.png';
import '../styles/Header.css';// <-- подключаем стили ТОЛЬКО для хедера

const Header = () => {
  /* ----------------- state ----------------- */
  const [isAuthenticated, setIsAuthenticated]   = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isContactOpen,   setIsContactOpen]     = useState(false);

  const navigate = useNavigate();

  /* ----------------- auth check ----------------- */
  useEffect(() => {
    setIsAuthenticated(!!localStorage.getItem('authToken'));
  }, []);

  /* ----------------- mobile menu handlers ----------------- */
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(prev => !prev);
    document.body.style.overflow = !isMobileMenuOpen ? 'hidden' : 'auto';
  };
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  /* ----------------- logout ----------------- */
  const handleLogout = () => {
    localStorage.removeItem('authToken');
    setIsAuthenticated(false);
    navigate('/');
    closeMobileMenu();
  };

  /* ----------------- contact popup handlers ----------------- */
  const openContact  = () => { setIsContactOpen(true);  document.body.style.overflow = 'hidden'; };
  const closeContact = useCallback(() => { setIsContactOpen(false); document.body.style.overflow = 'auto'; }, []);

  /* закрываем Esc */
  useEffect(() => {
    if (!isContactOpen) return;
    const handleEsc = (e) => e.key === 'Escape' && closeContact();
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isContactOpen, closeContact]);

  /* ----------------- render ----------------- */
  return (
    <>
      <header className="site-header">
        <div className="container header-inner">

          {/* -------- logo -------- */}
          <Link to="/" className="logo" onClick={closeMobileMenu}>
            <img src={logoImage} alt="Logo" />
          </Link>

          {/* -------- desktop nav -------- */}
          <nav className="desktop-nav">
            <ul>
              <li><Link to="/"        onClick={closeMobileMenu}>Главная</Link></li>
              <li><Link to="/cars"    onClick={closeMobileMenu}>Каталог</Link></li>
              <li><Link to="/about"   onClick={closeMobileMenu}>О нас</Link></li>
              <li><Link to="/terms"   onClick={closeMobileMenu}>Условия аренды</Link></li>
              <li><Link to="/contacts"onClick={closeMobileMenu}>Контакты</Link></li>
              {isAuthenticated && (
                <li><Link to="/profile" onClick={closeMobileMenu}>Профиль</Link></li>
              )}
            </ul>
          </nav>

          {/* -------- buttons -------- */}
          <div className="header-buttons">
            <button className="btn-primary" onClick={openContact}>Связаться</button>

            {isAuthenticated ? (
              <button className="btn-primary" onClick={handleLogout}>Выйти</button>
            ) : (
              <Link to="/auth"><button className="btn-primary">Вход / Регистрация</button></Link>
            )}
          </div>

          {/* -------- burger -------- */}
          <button
            className={`burger ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Меню"
          >
            {isMobileMenuOpen ? <FaTimes size={22}/> : <FaBars size={22}/>}
          </button>
        </div>
      </header>

      {/* -------- mobile menu -------- */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <ul>
          <li><Link to="/"         onClick={closeMobileMenu}>Главная</Link></li>
          <li><Link to="/cars"     onClick={closeMobileMenu}>Каталог</Link></li>
          <li><Link to="/about"    onClick={closeMobileMenu}>О нас</Link></li>
          <li><Link to="/terms"    onClick={closeMobileMenu}>Условия аренды</Link></li>
          <li><Link to="/contacts" onClick={closeMobileMenu}>Контакты</Link></li>
          {isAuthenticated && (
            <li><Link to="/profile" onClick={closeMobileMenu}>Профиль</Link></li>
          )}
          <li className="mobile-auth">
            {isAuthenticated ? (
              <button className="btn-primary" onClick={handleLogout}>Выйти</button>
            ) : (
              <Link to="/auth" onClick={closeMobileMenu}>
                <button className="btn-primary">Вход / Регистрация</button>
              </Link>
            )}
          </li>
        </ul>
      </div>

      {/* -------- contact popup -------- */}
      {isContactOpen && (
        <div className="contact-overlay" onClick={closeContact}>
          <div className="contact-card" onClick={e => e.stopPropagation()}>
            <button className="close-btn" onClick={closeContact}><FaTimes size={16}/></button>

            <a
              href="https://t.me/Reservecar_ru"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
            >
              💬 Написать в Telegram
            </a>

            <a href="tel:+79062699994" className="contact-link">
              📞 +7&nbsp;(906)&nbsp;269-99-94
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
